module.exports = __webpack_public_path__ + "img/07-interoperability-standards.7887d6e4.jpg";